import React from 'react'
import { PricingAvailabilityItem } from '@src/aem-content/aem-types'
import { useAddToCartWithGlobalSnackbar } from '@src/utils/useCart'
import { Formik } from 'formik'
import DiscoPromoMaterial from './DiscoPromoMaterial'

type DiscoPromoMaterialPriceFormProps = {
  index: number
  material: PricingAvailabilityItem
  dchainMessage?: string
}

export interface AddToCartFormValues {
  [key: string]: {
    materialNumber: string
    quantity: number | string
  }
}

const DiscoPromoMaterialPriceForm = ({
  index,
  material,
  dchainMessage,
}: DiscoPromoMaterialPriceFormProps) => {
  const handleAddToCart = useAddToCartWithGlobalSnackbar()

  if (!material) return null

  const loadInitialFormValues = (
    productPricing: PricingAvailabilityItem | null
  ): AddToCartFormValues => {
    if (!productPricing) {
      return {}
    }

    const { materialNumber } = productPricing
    return {
      [index]: {
        materialNumber,
        quantity: '',
      },
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={loadInitialFormValues(material)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        const materialValues = values[index]
        if (materialValues?.quantity) {
          const items = [
            {
              materialNumber: materialValues.materialNumber,
              quantity: Number(materialValues.quantity),
            },
          ]
          handleAddToCart(items, setSubmitting, resetForm)
        }
      }}
    >
      {({
        isSubmitting,
        dirty,
        submitForm,
        resetForm,
        setFieldValue,
        values,
      }) => (
        <DiscoPromoMaterial
          index={index}
          material={material}
          isSubmitting={isSubmitting}
          dirty={dirty}
          submitForm={submitForm}
          resetForm={resetForm}
          setFieldValue={setFieldValue}
          values={values}
          dchainMessage={dchainMessage}
        />
      )}
    </Formik>
  )
}
export default DiscoPromoMaterialPriceForm
